import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = { class: "partner-list" };
var _hoisted_2 = ["src"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'PartnerList',
    props: {
        partners: {
            type: Object,
            required: true
        }
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            var _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.partners, function (partner) {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "partner-list__slide",
                        key: partner.id
                    }, [
                        _createVNode(_component_router_link, {
                            class: "partner-list__card",
                            to: "/partner/".concat(partner.id)
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("img", {
                                    class: "partner-list__logo",
                                    src: partner.logo
                                }, null, 8, _hoisted_2)
                            ]; }),
                            _: 2
                        }, 1032, ["to"])
                    ]));
                }), 128))
            ]));
        };
    }
});
